export enum LinkRelationship {
    Parent = 'Parent',
    Child = 'Child',
    Reference = 'Reference',
    From = 'From',
    To = 'To'
}

/**
 * > Create Quote In Job > Quote Tab
 * 
 * quote.Link.RelationshipToJob = Child
 * 
 * job.Link.RelationshipToQuote = Parent
 * 
 * 
 */